//@flow
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel';
import useMediaQuery from 'react-responsive/src/useMediaQuery';
import { VenetianBlinds } from 'components/molecules/venetianBlinds';
import CarouselStatements from 'components/atoms/horizontalCarouselStatements';
import { useViewport } from 'components/templates/viewportProvider';
import { Counter } from 'components/atoms/counter';
import { StringUtil } from 'utils/StringUtil';
import 'animate.css/animate.css';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  result: Object,
  count: number,
  image: string,
  type?: string,
  thumbnailImage?: string,
  displayCard?: boolean,
  displayCount?: boolean,
  cardImage?: string,
  animationKey?: string,
  cardTitle?: string,
  previousImage: string,
  mediaPath?: string,
  pageValue?: number,
};

const HorizontalCarousel = (props: Props) => {
  const { height } = useViewport();
  const isTablet = useMediaQuery({ maxDeviceWidth: 1024 });
  if (!props) {
    return null;
  }

  const {
    type,
    count,
    result,
    image,
    mediaPath,
    animationKey,
    previousImage,
    thumbnailImage,
    displayCount = true,
  } = props;

  const slideCount = displayCount === false ? 'hide-count' : 'slide-count';
  const image_length =
    type === 'projects' &&
    result &&
    result[count].images &&
    result[count].images.length;

  return (
    <Row style={{ height: '100%' }}>
      <Col className={'left-section'} md={{ span: isTablet ? 5 : 4 }}>
        <Row className={'carousel-inner-row'}>
          <Col md={{ span: 10 }}>
            <CarouselStatements
              containerClassName={'statements'}
              headingClassName={'section-heading'}
              subHeadingClassName={'sub-heading'}
              descriptionClassName={'paragraph'}
              heading={
                result[count].heading &&
                StringUtil.sliceHtml(result[count].heading)
              }
              subHeading={
                result[count].sub_heading && result[count].sub_heading
              }
              description={
                result[count].description && result[count].description
              }
              animationKey={animationKey}
            />
          </Col>
        </Row>
      </Col>
      <Col
        className={
          type === 'restaurant' || type === 'campaign'
            ? 'section-banner-image-toggle'
            : 'section-banner-image'
        }
        md={{ span: isTablet ? 7 : 8 }}
      >
        <div className={'image-div'}>
          {type === 'projects' ? (
            <Carousel
              className={image_length > 1 ? 'projects' : 'project no-control'}
              pauseOnHover={false}
              controls={true}
              interval={7000}
              pause={false}
              fade={true}
              nextIcon={
                image_length > 1 && (
                  <span className={'carousel-control-next-icon'} />
                )
              }
              prevIcon={
                image_length > 1 && (
                  <span className={'carousel-control-prev-icon'} />
                )
              }
            >
              {result &&
                result[count] &&
                result[count].images.map((slides, idx) => {
                  return (
                    <Carousel.Item key={idx}>
                      <img
                        className={'carousel-image'}
                        src={`${mediaPath}/${slides}`}
                        alt={'broken'}
                        height={isTablet ? height : {}}
                      />
                    </Carousel.Item>
                  );
                })}
            </Carousel>
          ) : (
            <React.Fragment>
              <VenetianBlinds
                imageUrl={image}
                thumbnailImage={thumbnailImage}
                backgroundImageUrl={previousImage}
              />
            </React.Fragment>
          )}
        </div>
      </Col>
      <Counter count={count} type={'big'} className={slideCount} />
    </Row>
  );
};

export default HorizontalCarousel;
